import { password } from "../../config";

export const  decryptData = ( async (encryptedData)=>{
    // Helper pour décoder du Base64 vers un Uint8Array
  const decodeBase64 = (b64) => Uint8Array.from(atob(b64), c => c.charCodeAt(0));

  // 1-2. Décoder les champs Base64 en tableaux d'octets
  const ivBytes = decodeBase64(encryptedData.iv);
  const saltBytes = decodeBase64(encryptedData.salt);
  const ciphertextBytes = decodeBase64(encryptedData.ciphertext);
  const tagBytes = decodeBase64(encryptedData.tag);

  // 3. Importer le mot de passe et dériver la clé AES-256-GCM via PBKDF2 (paramètres identiques au serveur)
  const enc = new TextEncoder();
  const passwordKey = await crypto.subtle.importKey(
    "raw", 
    enc.encode(`${process.env.REACT_APP_DECRYPTO_ENCRYPTO_ELAKAY}`), 
    { name: "PBKDF2" }, 
    false, 
    ["deriveKey"]
  );
  const aesKey = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: saltBytes,
      iterations: 100000,
      hash: "SHA-256"
    },
    passwordKey,
    { name: "AES-GCM", length: 256 },
    false, 
    ["decrypt"]
  );

  // 4. Combiner ciphertext + tag en un seul buffer
  const encryptedContent = new Uint8Array(ciphertextBytes.length + tagBytes.length);
  encryptedContent.set(ciphertextBytes, 0);
  encryptedContent.set(tagBytes, ciphertextBytes.length);

  // 5. Déchiffrer avec AES-GCM
  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: ivBytes, tagLength: 128 },
    aesKey,
    encryptedContent
  );

  // 6. Convertir le résultat binaire en texte puis en JSON
  const decryptedText = new TextDecoder().decode(decryptedBuffer);
  return JSON.parse(decryptedText);

})